import React from "react"
import propTypes from "prop-types"

import ErrorMessage from "../ErrorMessage"

const GeneralErrorMessage = ({ message }) => {
  return (
    <>
      {message && (
        <div className="form_group">
          <ErrorMessage message={message} />
        </div>
      )}
    </>
  )
}

GeneralErrorMessage.propTypes = {
  message: propTypes.string
}

GeneralErrorMessage.defaultProps = {
  message: ""
}

export default GeneralErrorMessage
